import dayjs from 'dayjs'

import { ClassifiedCarabinBlock } from '../../rest/types/Classified'

export function BlockJobTransformer({
  block,
  t,
}: {
  block: ClassifiedCarabinBlock
  t: any
}) {
  return {
    ...((block?.speciality?.name || block?.cabinetType?.name) && {
      adsTypes: {
        texts: {
          seeLess: t('ads_types_see_less'),
          seeMore: t('ads_types_see_more'),
        },
        items: [
          ...(block?.speciality?.name
            ? [
                {
                  title: t('ads_types_speciality_title'),
                  text: block?.speciality?.name,
                },
              ]
            : []),

          ...(block?.cabinetType
            ? [
                {
                  title: t('ads_types_cabinet_type_title'),
                  text: block?.cabinetType?.name,
                },
              ]
            : []),
        ],
      },

      adsReplacementDate: {
        title: t('ads_replacement_date_title'),
        subtitle: {
          label: t('ads_replacement_date_carabin_subtitle'),
          requestedDate: dayjs(block?.startDate).format('DD MMMM YYYY'),
        },
        periods: {
          label: t('ads_replacement_date_period_label'),
          start: dayjs(block?.startDate).format('DD MMMM YYYY'),
          finish: dayjs(block?.endDate).format('DD MMMM YYYY'),
        },
      },

      adsHighlight: {
        title: t('ads_highlight_job_title'),
        text: t('ads_highlight_job_text'),
        button: {
          label: t('ads_highlight_button_label'),
          href: t('ads_intro_link_href_job'),
        },
      },
    }),
  }
}
